import { render, staticRenderFns } from "./OfficeForHall.vue?vue&type=template&id=4e7b737c&scoped=true&"
import script from "./OfficeForHall.vue?vue&type=script&lang=js&"
export * from "./OfficeForHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b737c",
  null
  
)

export default component.exports